<div class="content">
    <h1 class="mb-3">Contact</h1>
    kloppferski@gmail.com
</div>